import { cn } from "@/modules/lib/utils"
import { UserGridItem } from "@modules/chat/components/userGridItem"
import { GetStreamUserEntity } from "@modules/chat/entities/getStreamUserEntity"

type UserSearchSelectionProps = {
  users: GetStreamUserEntity[]
  onRemoveUser: (index: number) => void
  className?: string
} & React.ComponentProps<"div">

export function UserSearchSelection({ users, onRemoveUser, className, ...props }: UserSearchSelectionProps) {
  return (
    <div
      className={cn(
        "mt-2 flex flex-row items-center justify-start overflow-x-auto border-b border-neutral-600 py-2",
        className,
      )}
      style={{ minHeight: "fit-content" }}
      {...props}
    >
      {users.map((user, index) => (
        <UserGridItem key={index} user={user} onRemoveUser={() => onRemoveUser(index)} removeButton />
      ))}
    </div>
  )
}
